import { api } from 'services/api'
import { GrassType, Post } from './types'


export const getGrass = () => {
  return api.get<GrassType[]>('/grass').then(response => response.data)
}

export const getDetailsGrass = (id: string) => {
  return api.get<Post[]>(`/grass/?slug=${id}`).then(response => response.data[0])
}